import {
  useUserAttributesControllerGetUserAttribute,
  useUserAttributesControllerGetUserAttributesList,
  useUserAttributesControllerUpdateUserAttributes,
} from '@docnboard/rest';

export const useUpdateUserAttributes =
  useUserAttributesControllerUpdateUserAttributes;

export const useGetUserAttribute = useUserAttributesControllerGetUserAttribute;

export const useGetUserAttributesList =
  useUserAttributesControllerGetUserAttributesList;
